module.exports = __webpack_public_path__ + "img/ebook_gg.da80a572.png";